<mat-table [dataSource]="unreadObjects">
  <!-- Name Column -->
  <ng-container matColumnDef="name">
    <mat-cell *matCellDef="let element">
      <div class="name-container">
        <div>{{ element.name }}</div>
        @if (element.subName) {
          <div class="subname">{{ element.subName }}</div>
        }
      </div>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="count">
    <mat-cell *matCellDef="let element">
      <div class="count-container">
        {{ element.count }}
      </div>
    </mat-cell>
  </ng-container>

  <!-- Table Rows -->
  <mat-row *matRowDef="let row; columns: ['name', 'count']" (click)="showComments(row)" class="row"></mat-row>
</mat-table>
